import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Grid, Modal } from '../../canvasComponents/index';
// scss
import '../../css/components/PopUps/PopUps.scss';
// messages
import messages from './messages';

function ConsentPopUp(props) {
  const { open, closeAdjusterDetailsPopUp, data } = props;
  const { name, phone, email, oracleId } = data || '';

  const onCloseHandler = () => {
    closeAdjusterDetailsPopUp();
  };

  return (
    <Modal
      id="adjuster_details"
      isOpen={open}
      ariaHideApp={false}
      onRequestClose={onCloseHandler}
    >
      <div className="modal-grid-adj">
        <Grid>
          <div className="pop-up-title">
            <p><FormattedMessage {...messages.adjusterInformation} /></p>
          </div>
          <div>
            {oracleId && (
              <>
                <span className="pop-up-subtitle"><FormattedMessage {...messages.name} /></span>
                <span className="pop-up-text" /> {name}
                <br />
              </>
            )}
            {phone && (
              <>
                <span className="pop-up-subtitle"><FormattedMessage {...messages.phone} /></span>
                <span className="pop-up-text" /> {phone}
                <br />
              </>
            )}
            {email && (
              <>
                <span className="pop-up-subtitle"><FormattedMessage {...messages.email} /></span>
                <span className="pop-up-text" /> {email}
              </>
            )}
          </div>
        </Grid>
      </div>
    </Modal>
  );
}

export default injectIntl(ConsentPopUp);
